var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff7224",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,21h-10c-1.657,0 -3,-1.343 -3,-3v-12c0,-1.657 1.343,-3 3,-3h8l5,6v9c0,1.657 -1.343,3 -3,3z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7v-4l5,6h-3c-1.105,0 -2,-0.895 -2,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10v0c-0.828,0 -1.5,0.672 -1.5,1.5v4c0,0.828 0.672,1.5 1.5,1.5v0c0.828,0 1.5,-0.672 1.5,-1.5v-4c0,-0.828 -0.672,-1.5 -1.5,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,11v0c-0.828,0 -1.5,0.672 -1.5,1.5v3c0,0.828 0.672,1.5 1.5,1.5v0c0.828,0 1.5,-0.672 1.5,-1.5v-3c0,-0.828 -0.672,-1.5 -1.5,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,13v0c-0.828,0 -1.5,0.672 -1.5,1.5v1c0,0.828 0.672,1.5 1.5,1.5v0c0.828,0 1.5,-0.672 1.5,-1.5v-1c0,-0.828 -0.672,-1.5 -1.5,-1.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationFile);
export default __webpack_public_path__ + "static/media/PresentationFile.a779dfc40f8f10d1a50908bd4f37f379.svg";
export { ForwardRef as ReactComponent };